var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-form",
        { ref: "queryForm", attrs: { inline: true, "label-width": "120px" } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("RoleManagement.child.name"),
                prop: "roleName",
              },
            },
            [
              _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  value: _vm.roleName,
                  disabled: "",
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "mb8", attrs: { gutter: 10 } },
        [
          _c(
            "el-col",
            { staticClass: "top-left-btn", attrs: { span: 1.5 } },
            [
              _c(
                "el-button",
                {
                  staticClass: "delete-btn",
                  attrs: { type: "primary", disabled: _vm.multiple },
                  on: { click: _vm.onDeleteSelected },
                },
                [_vm._v(_vm._s(_vm.$t("delText")))]
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "top-left-btn", attrs: { span: 1.5 } },
            [
              _c(
                "el-button",
                {
                  staticClass: "main-btn",
                  attrs: { type: "primary" },
                  on: { click: _vm.handleAdd },
                },
                [_vm._v(_vm._s(_vm.$t("RoleManagement.child.add")))]
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 1.5 } },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.complete("BusinessUserRoleAdminCSG")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("backText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "table",
          attrs: { data: _vm.userTableData },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("el-table-column", {
            attrs: { type: "selection", width: "55", align: "center" },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("RoleManagement.child.role"),
              align: "center",
              prop: "loginName",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("RoleManagement.child.rolename"),
              align: "center",
              prop: "realName",
            },
          }),
        ],
        1
      ),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.queryParams.total > 0,
            expression: "queryParams.total > 0",
          },
        ],
        attrs: {
          total: _vm.queryParams.total,
          page: _vm.queryParams.page,
          limit: _vm.queryParams.size,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.queryParams, "page", $event)
          },
          "update:limit": function ($event) {
            return _vm.$set(_vm.queryParams, "size", $event)
          },
          pagination: _vm.getList,
        },
      }),
      _c("BjDialogList", {
        ref: "dialogList",
        attrs: {
          config: _vm.dialogListConfig,
          disabled: _vm.disabledIds,
          multiple: "",
        },
        on: { confirm: _vm.onConfirmDialogList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }